import React from 'react';

const Enquiries = () => {
  return (
    <div>
      <h1>Enquiries</h1>
      <p>
        For all enquiries, please contact us at <a href="mailto:info@icebergers.org">info@icebergers.org</a>.
      </p>
           <p>
        RBYC.org.au membership information -{'>'} <a href="https://rbyc.org.au/club/membership/" target="_blank" without rel="noreferrer">
        https://rbyc.org.au/club/membership/
          </a>
      </p>
      
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default Enquiries;